import React, { useRef } from 'react';
import HeaderWithoutLang from '../HeaderWithoutLang';
import Footer from '../Footer';
import CommercialVehicleChooseUsSection from '../commercialVechiclePage/CommercialVehicleChooseUsSection';
import InventoryFinancingBusinessSection from './InventoryFinancingBusinessSection';
import InventoryFinancingHeroSection from './InventoryFinancingHeroSection';
import {useTranslation} from "react-i18next";
import usePageTitle from '../../hooks/usePageTitle';

const InventoryFinancingPage = () => {
    usePageTitle('Get a Supply Chain Financing loan on your invoice - GrowBizh');
    const heroRef = useRef(null);
    const handleClick = () => {
        heroRef.current?.scrollIntoView({behavior: 'smooth'});
    };
    const {t} =useTranslation('inventoryFinancingPage');
    const content= t('inventory-financing-choose-us-section-description');
    const productType="Inventory Financing Loan";
    return (
        <>
            <HeaderWithoutLang/>
            <InventoryFinancingHeroSection ref={heroRef} onScrollToForm={handleClick}/>
            <InventoryFinancingBusinessSection/>
            <CommercialVehicleChooseUsSection content={content} onApplyNowClick={handleClick}/>
            <Footer/>
        </>
    );
}

export default InventoryFinancingPage;